import React from 'react';
import {
  PreviewContainer,
  PreviewHeading,
  PreviewContent,
  PreviewFormContainer,
} from './NonMemberSignup.styled';
import NonMemberSignupForm from './NonMemberSignupForm/NonMemberSignupForm';

const NonMemberSignupFormPreview = ({
  headerText,
  logoUrl,
  organizationName,
}) => {
  return (
    <PreviewContainer>
      <PreviewContent>
        <PreviewHeading>Form Preview</PreviewHeading>
        <PreviewFormContainer>
          <NonMemberSignupForm
            preview={true}
            headerText={headerText}
            logoUrl={logoUrl}
            organizationName={organizationName || ''}
          />
        </PreviewFormContainer>
      </PreviewContent>
    </PreviewContainer>
  );
};

export default NonMemberSignupFormPreview;
